import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import Template from './template.vue';
import RestrictedMixin from '@/mixins/RestrictedMixin';
import ListadosMixin from '@/mixins/ListadosMixin';
import { Validator } from 'vee-validate';
import AuthMixin from '@/mixins/AuthMixin';
import { Rol } from '@/store/modules/rol/types';

const namespace: string = 'usuarioModule';

@Component({
  mixins: [Template, AuthMixin, RestrictedMixin, ListadosMixin],
  props: ['usuario', 'agregando'],
})
export default class ProyectoForma extends Vue {
  @Inject('$validator') public $validator!: Validator;
  // tslint:disable-next-line: ban-types
  @Action('addUsuario', { namespace }) private addUsuario!: Function;
  // tslint:disable-next-line: ban-types
  @Action('updateUsuario', { namespace }) private updateUsuario!: Function;
  // tslint:disable-next-line: ban-types
  @Action('deleteUsuario', { namespace }) private deleteUsuario!: Function;

  // tslint:disable-next-line: ban-types
  @Action('getRoles', { namespace: 'rolModule' }) private getRoles!: Function;
  @Getter('roles', { namespace: 'rolModule' }) private roles!: Rol[];

  private editable: boolean = true;
  private cambiaPass: boolean = false;
  private pass1: string = '';
  private pass2: string = '';

  private mounted() {
    this.getRoles();
  }

  private async validate() {
    const rol = this.roles.find((elem: Rol) => elem.id === this.$props.usuario.idrol);
    if (rol !== undefined) {
      let rr = rol.nombre.toLowerCase();
      if (rr === 'administrador') {
        rr = 'admin';
      }
      this.$props.usuario.rol = rr;
    }
    //
    const validator = await this.$validator.validateAll();
    if (validator) {
      if (!this.$props.usuario.created_at) {
        this.$props.usuario.created_at = new Date().toISOString();
      }
      this.$props.usuario.updated_at = new Date().toISOString();
      if (this.$props.agregando) {
        this.$props.usuario.password = this.pass1;
        this.addUsuario(this.$props.usuario);
      } else {
        if (this.cambiaPass) {
          this.$props.usuario.password = this.pass1;
        }
        this.updateUsuario(this.$props.usuario);
      }
      this.$emit('cerrar', true);
    }
  }

  @Watch('usuario')
  private onSetUsuario() {
    this.cambiaPass = false;
    this.pass1 = '';
    this.pass2 = '';
    this.$validator.reset();
  }

}
